import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { loadProject } from '../../actions/project'
import slugFromUrl from '../../utils/slugFromUrl'
import Creator from './withLoadProject'

const mapStateToProps = state => ({
  projectName: dotProp.get(state, 'project.name', ''),
})

const mapDispatchToProps = dispatch => ({
  load: () => dispatch(loadProject(slugFromUrl(window))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Creator)



// WEBPACK FOOTER //
// ./src/screens/Creator/index.js